import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page

    /**************************************************************
    -> Pageload animation
    **************************************************************/
   function pageSingleExperienceLoadAnimation() {
    const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

    tl.to('.hero-single-experience .wrap-fullscreen-image', { opacity: 1 })
    .to('.hero-single-experience .dark-overlay-hero', { opacity: 1 }, '>-0.15')
    .to('.hero-single-experience .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    .to('.hero-single-experience .wrap-hero-header h3', { opacity: 1 }, '>-0.35')
  }
  pageSingleExperienceLoadAnimation()

    /**************************************************************
    -> Single Experiences wishlist button anim on scroll
    **************************************************************/
   function inViewAnimSingleExperienceHighlights() {
    gsap.fromTo('.wrap-highlights' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.75,
      duration: 0.5,
      scrollTrigger: '.wrap-highlights',
    })
  }
  inViewAnimSingleExperienceHighlights();

  /**************************************************************
  -> Single Experiences buttons anim on scroll
  **************************************************************/
  function inViewAnimSingleExperienceButtons() {
    gsap.fromTo('.wrap-buttons-experiences' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.75,
      duration: 0.5,
      scrollTrigger: '.wrap-buttons-experiences',
    })
  }
  inViewAnimSingleExperienceButtons();


  /**************************************************************
  -> Single Experiences overview anim on scroll
  **************************************************************/
  function inViewAnimSingleExperienceOverview() {
    gsap.fromTo('.wrap-overview-exp .wrap-overview-text h2' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.wrap-overview-exp .wrap-overview-text',
    })

    gsap.fromTo('.wrap-overview-exp .wrap-overview-text p' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.wrap-overview-exp .wrap-overview-text',
    })

    gsap.fromTo('.wrap-overview-exp .wrap-carousel' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.wrap-overview-exp .wrap-carousel',
    })
  }
  inViewAnimSingleExperienceOverview();

  /**************************************************************
  -> Single Experience Itinerary anim on scroll
  **************************************************************/
  function inViewAnimSingleExperienceItinerary() {
    gsap.fromTo('.wrap-itinerary .wrap-itinerary-text h2' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.wrap-itinerary .wrap-itinerary-text',
    })

    gsap.fromTo('.wrap-itinerary .wrap-itinerary-text p' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.wrap-itinerary .wrap-itinerary-text',
    })

    gsap.fromTo('.container-itinerary .itinerary-content' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.container-itinerary .itinerary-content',
    })

    gsap.fromTo('.container-itinerary .itinerary-summary .day-line' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.25,
      stagger: {
        each: 0.05,
        from: 'start',
        grid: 'auto',
        ease: 'linear',
      },
      scrollTrigger: '.container-itinerary .itinerary-summary',
    })

    gsap.fromTo('.container-itinerary .itinerary-summary .call-us-block' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.85,
      duration: 0.5,
      scrollTrigger: '.container-itinerary .itinerary-summary .call-us-block',
    })
  }
  inViewAnimSingleExperienceItinerary();

  /**************************************************************
  -> Single Experience Similar Experiences anim on scroll
  **************************************************************/
  function inViewAnimSingleExperienceSimilarExperiences() {
    gsap.fromTo('.similar-experiences-single-experience .wrap-text' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.similar-experiences-single-experience .wrap-text',
    })

    gsap.fromTo('.similar-experiences-single-experience .wrap-carousel' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.25,
      duration: 0.5,
      scrollTrigger: '.similar-experiences-single-experience .wrap-carousel',
    })

    gsap.fromTo('.similar-experiences-single-experience .wrap-link-back' , 
    { opacity: 0 },
    {
      opacity: 1,
      delay: 0.5,
      duration: 0.5,
      scrollTrigger: '.similar-experiences-single-experience .wrap-link-back',
    })
  }
  inViewAnimSingleExperienceSimilarExperiences();

    // eslint-disable-next-line no-unused-vars
    let overviewSwiper = new Swiper ('.swiper-container-overview-single-experiences', {
      loop: true,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      centeredSlides: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.2,
          spaceBetween: 5,
          centeredSlides: true,
          slidesOffsetBefore: 0,
        },
        // when window width is >= 760px
        760: {
          slidesPerView: 1.35,
          spaceBetween: 10,
          centeredSlides: true,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 15,
          centeredSlides: true,
        },
        // when window width is >= 1920px
        1920: {
          slidesPerView: 2.5,
          spaceBetween: 15,
          centeredSlides: true,
        },
      },
    })

    // eslint-disable-next-line no-unused-vars
    let similarExperiencesSwiper = new Swiper ('.swiper-container-single-experiences-similar-experiences', {
      // loop: true,
      slidesPerView: 3.5,
      // centeredSlides: false,
      // roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-similar-experiences-button-next',
        prevEl: '.swiper-similar-experiences-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.2,
        },
        // when window width is >= 760px
        760: {
          slidesPerView: 2.2,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3.2,
        },
        // when window width is >= 1920px
        1920: {
          slidesPerView: 3.8,
        },
      },
    })

    let itineraryDaySwiper;

    if (window.innerWidth <= 769) {
      // eslint-disable-next-line no-unused-vars
      itineraryDaySwiper = new Swiper ('.swiper-container-itinerary-days', {
        centeredSlides: true,
        grabCursor: true,
        speed: 250,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          // when window width is >= 760px
          769: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
        // HERE THIS IS THE CODE FOR THE TOUCHEND EVENT ON THE DAY SLIDER
        // on: {
        //   touchEnd: function() {
        //     setTimeout(() => {
        //       gsap.to(window, {duration: 1, scrollTo: {y: `.each-day-content[data-day-index="${this.realIndex}"]`, offsetY: 90 }});
        //     }, 400);
        //   },
        // },
      })
    }

    // itinerary Acoomodation slider
    // eslint-disable-next-line no-unused-vars
    let itineraryAccomodationSwiper = new Swiper ('.swiper-container-itinerary-accomodations', {
      loop: true,
      slidesPerView: 1,
      // roundLengths: true,
      grabCursor: true,
      speed: 500,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      on: {
        init: function() {
          if(this.slides.length - 2 == 1) {
            this.detachEvents();
          }
        },
      },
    })

     /**************************************************************
    -> Open lightbox Accommodation on click on info icon
    **************************************************************/
    const eachDaysContent = Array.from(document.querySelectorAll('.each-day-content'))
    eachDaysContent.forEach(day => {
      const dayId = day.dataset.dayIndex;
      const eachDaysRelatedInfoButtons = Array.from(day.querySelectorAll('.wrap-related-accomodations .info-icon'))

      eachDaysRelatedInfoButtons.forEach(infoButton => {
        infoButton.addEventListener('click', () => {
          const infoButtonId = infoButton.dataset.id;
          const lightbox = document.querySelector(`.each-day-content[data-day-index="${dayId}"] .lightbox[data-id="${infoButtonId}"]`)
          const close = lightbox.querySelector('.close')
          const dropdownBtn = lightbox.querySelector('.dropdown-btn')
          const dropdown = lightbox.querySelector('.dropdown')

          if (dropdownBtn) {
            dropdownBtn.addEventListener('click', function() {
              dropdownBtn.classList.toggle('open')
              dropdown.classList.toggle('open')
            })
          }
          lightbox.classList.add('active')

          // itinerary Acoomodation slider
          // eslint-disable-next-line no-unused-vars
          let lightboxAccomodationSwiper = new Swiper ('.swiper-container-lightbox-accomodations', {
            // loop: true,
            slidesPerView: 1,
            // roundLengths: true,
            grabCursor: true,
            speed: 500,
            navigation: {
              nextEl: '.swiper-accommodation-lightbox-button-next',
              prevEl: '.swiper-accommodation-lightbox-button-prev',
            },
          })

          close.addEventListener('click', () => {
            lightbox.classList.remove('active')
          })

          
        })
      })
    })

    // Below is the code related to intersection observer for itinerary stuff
    // eslint-disable-next-line no-unused-vars
    const swiperDays = document.querySelectorAll('.swiper-container-itinerary-days .swier-slide');
    const itineraryDays = document.querySelectorAll('.each-day-content');
    const dayLines = document.querySelectorAll('.day-line');
    // let locked = false;

    let options = {
      root: document.querySelector('.intersection-observer-root-element'),
      rootMargin: '0px 0px 0px 0px',
      threshold: [0, 0.25, 0.5, 0.75, 1],
    }

    let observer = new IntersectionObserver(
    // eslint-disable-next-line no-unused-vars
    (entries, observer) => { 
      entries.forEach(entry => {
        if(entry.isIntersecting){
          dayLines.forEach(line => {
            const thisLine = line.dataset.dayHighlight - 1;

            if (thisLine == entry.target.dataset.dayIndex) {
              line.classList.add('active');
              line.querySelector('.background-highlight').classList.add('active');
            }
          })
          // HERE IS THE CODE FOR THE INTERSECTION OBSERVER ON MOBILE DEVICE
          // eslint-disable-next-line no-unused-vars
          if (itineraryDaySwiper && window.innerWidth <= 769) {
            // itineraryDaySwiper.on('touchEnd', () => {
            //   locked = true;
            //   setTimeout(() => {
            //     locked = false;
            //   }, 500);
            // })

            // if (!locked) {
            //   setTimeout(() => {
                // if (itineraryDaySwiper.realIndex - itineraryDaySwiper.previousIndex < 0) {
                //   itineraryDaySwiper.slideTo(parseInt(entry.target.getAttribute('data-day-index')) + 1)
                // } else if (itineraryDaySwiper.realIndex - itineraryDaySwiper.previousIndex > 0) {
                //   itineraryDaySwiper.slideTo(entry.target.getAttribute('data-day-index'))
                // } else {
                  itineraryDaySwiper.slideTo(entry.target.getAttribute('data-day-index'))
                // }
              // }, 600);
            // }
          }            
        } else {
          dayLines.forEach(line => {
            const thisLine = line.dataset.dayHighlight - 1;
            if (thisLine == entry.target.dataset.dayIndex) {
              line.classList.remove('active');
              line.querySelector('.background-highlight').classList.remove('active');
            }
          });
        }
      });
    }, {options});

    itineraryDays.forEach(day => { observer.observe(day) });

    dayLines.forEach(day => {
      day.addEventListener('click', () => {
        // eslint-disable-next-line no-unused-vars
        const clickedIndex = day.dataset.dayHighlight - 1;
        itineraryDays.forEach(day => { 
          const thisIndex = day.dataset.dayIndex;

          if (clickedIndex == thisIndex) {
            gsap.to(window, {duration: 1, scrollTo: {y: day, offsetY: 50 }});
          }
        });        
      })
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-experiences.js